import { Reveal, Eyebrow } from "./Reveal";

const Card = ({ id, tag, title, body, className = "", dark, children }) => (
  <div data-testid={`ingredient-card-${id}`}
    className={`group relative flex h-full flex-col justify-between overflow-hidden rounded-[1.75rem] border p-6 transition-transform duration-500 hover:-translate-y-1 sm:p-8 ${dark ? "border-[#F2EDE4]/10 bg-[#0F2822]" : "border-transparent bg-[#F2EDE4]"} ${className}`}>
    {children}
    <span className={`relative font-mono text-[11px] uppercase tracking-[0.2em] ${dark ? "text-[#E5A93C]" : "text-[#B4532F]"}`}>{tag}</span>
    <div className="relative mt-10">
      <h3 className={`font-display text-2xl font-bold tracking-tight sm:text-3xl ${dark ? "text-[#F2EDE4]" : "text-[#091D18]"}`}>{title}</h3>
      <p className={`mt-3 max-w-md text-sm leading-relaxed sm:text-base ${dark ? "text-[#F2EDE4]/75" : "text-[#091D18]/75"}`}>{body}</p>
    </div>
  </div>
);

export const Bento = () => (
  <section id="ingredients" className="relative bg-[#091D18] py-24 sm:py-32" data-testid="ingredients-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow>What's inside</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#F2EDE4] sm:text-5xl">
            Five ingredients, <span className="font-serif italic font-normal text-[#D96B43]">one job.</span>
          </h2>
        </div>
        <p className="max-w-sm text-base text-[#F2EDE4]/70">Ingredient roles as described by the maker. Always check the official label for exact amounts.</p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-6 md:auto-rows-[260px] sm:gap-5">
        <Reveal className="md:col-span-4 md:row-span-2">
          <Card id="mobilee" tag="Hero ingredient" title="Mobilee®" dark className="min-h-[420px]"
            body="A patented matrix of hyaluronic acid, polysaccharides and collagen, chosen to support the lubricating fluid in your joints.">
            <div className="absolute right-[-10%] top-1/2 h-[70%] aspect-square -translate-y-1/2 rounded-full bg-[#E5A93C]/15 blur-3xl" />
            <img src="/joint-genesis-bottle.png" alt="Joint Genesis bottle" data-testid="bento-product-bottle"
              className="absolute right-2 top-8 w-[55%] max-w-[340px] drop-shadow-[0_25px_35px_rgba(0,0,0,0.5)] transition-transform duration-1000 group-hover:-rotate-3 group-hover:scale-105 sm:right-8 md:top-1/2 md:-translate-y-1/2" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F2822] via-[#0F2822]/40 to-transparent md:via-transparent" />
          </Card>
        </Reveal>
        <Reveal delay={0.08} className="md:col-span-2"><Card id="pine-bark" tag="Botanical" title="Pine bark" body="French maritime pine bark extract, rich in antioxidant compounds." /></Reveal>
        <Reveal delay={0.16} className="md:col-span-2"><Card id="boswellia" tag="Botanical" title="Boswellia" dark body="Boswellia serrata resin, used for centuries in traditional practice." /></Reveal>
        <Reveal delay={0.08} className="md:col-span-3"><Card id="ginger" tag="Root" title="Ginger root" dark body="A familiar kitchen root added for its soothing reputation." /></Reveal>
        <Reveal delay={0.16} className="md:col-span-3"><Card id="bioperine" tag="Absorption" title="BioPerine®" body="Black-pepper extract included to help the body absorb the rest of the formula." /></Reveal>
      </div>
    </div>
  </section>
);
